<script>
import { ROLE } from '@utils/constant'

export default {
  data: () => {
    return {
      navigations: [
        {
          _name: 'CSidebarNavItem',
          name: 'アライアンス管理',
          to: '/panel/agent-list',
          icon: 'cil-people',
          roles: [ROLE.SUPER],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: 'ユーザ管理',
          to: '/panel/member-list',
          icon: 'cil-user',
          roles: [ROLE.SUPER],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: '友達連携管理',
          to: '/panel/frield-list',
          icon: 'cil-thumb-up',
          roles: [ROLE.SUPER],
        },
        {
          _name: 'CSidebarNavItem',
          name: '計測情報管理',
          to: '/panel/measure-list',
          icon: 'cil-notes',
          roles: [ROLE.SUPER],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: 'デバイス管理',
          to: '/panel/device-list',
          icon: 'cil-tablet',
          roles: [ROLE.SUPER],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: 'デバイス・ユーザ連携管理',
          to: '/panel/device-user-list',
          icon: 'cil-puzzle',
          roles: [ROLE.SUPER],
        },
        {
          _name: 'CSidebarNavItem',
          name: 'マネージャ管理',
          to: '/panel/admin-list',
          icon: 'cil-list',
          roles: [ROLE.SUPER],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: 'お知らせ管理',
          to: '/panel/notification',
          icon: 'cil-envelope-open',
          roles: [ROLE.SUPER],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: 'ダッシュボード',
          to: '/panel/dashboard',
          icon: 'cil-speedometer',
          roles: [ROLE.AGENT_ADMIN, ROLE.AGENT_AUDIT, ROLE.AGENT_SUB],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: 'ユーザ管理',
          to: '/panel/member-list-agent-admin',
          icon: 'cil-user',
          roles: [ROLE.AGENT_ADMIN, ROLE.AGENT_AUDIT, ROLE.AGENT_SUB],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: '計測情報管理',
          to: '/panel/measure-list-agent',
          icon: 'cil-notes',
          roles: [ROLE.AGENT_ADMIN, ROLE.AGENT_AUDIT, ROLE.AGENT_SUB],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: 'デバイス管理',
          to: '/panel/device-list-agent-admin',
          icon: 'cil-list',
          roles: [ROLE.AGENT_ADMIN, ROLE.AGENT_AUDIT, ROLE.AGENT_SUB],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: 'アプリお知らせ管理',
          to: '/panel/notification_agentadmin',
          icon: 'cil-envelope-open',
          roles: [
            ROLE.AGENT_ADMIN,
            ROLE.AGENT_AUDIT,
            ROLE.AGENT_SUB,
            ROLE.AGENT_ANNOUNCE,
          ],
          exact: false,
        },
        {
          _name: 'CSidebarNavItem',
          name: 'お問い合わせ',
          to: '/panel/feedback',
          icon: 'cil-phone',
          roles: [
            ROLE.AGENT_ADMIN,
            ROLE.AGENT_AUDIT,
            ROLE.AGENT_SUB,
            ROLE.AGENT_ANNOUNCE,
          ],
          exact: false,
        },
      ],
    }
  },
  computed: {
    show() {
      return this.$store.state.common.sidebarShow
    },
    minimize() {
      return this.$store.state.common.sidebarMinimize
    },
    currentNavigations() {
      const role = this.$store.getters['auth/getCurrentUser']
      return this.navigations.filter((item) => {
        return !item.roles || item.roles.includes(role?.level)
      })
    },
    computedSidebar() {
      return [
        {
          _name: 'CSidebarNav',
          _children: this.currentNavigations,
        },
      ]
    },
  },
}
</script>

<template>
  <CSidebar
    id="base-side-bar"
    fixed
    :minimize="minimize"
    :show="show"
    @update:show="
      (value) =>
        $store.commit('common/SET_SIDEBAR_STATE', ['sidebarShow', value])
    "
  >
    <CSidebarBrand class="d-md-down-none text-decoration-none" to="/">
      <CIcon
        class="c-sidebar-brand-full"
        name="logo"
        size="custom-size"
        :height="35"
        view-box="0 0 662 200"
      />
      <CIcon
        class="c-sidebar-brand-minimized"
        name="logoMini"
        size="custom-size"
        :height="35"
        view-box="0 0 200 200"
      />
    </CSidebarBrand>

    <CRenderFunction flat :content-to-render="computedSidebar" />
    <CSidebarMinimizer
      class="d-md-down-none"
      @click.native="
        $store.commit('common/SET_SIDEBAR_STATE', [
          'sidebarMinimize',
          !minimize,
        ])
      "
    />
  </CSidebar>
</template>

<style lang="scss" scoped>
#base-side-bar {
  max-width: 240px;

  ::v-deep .c-active {
    > svg {
      color: map-get($map: $theme-colors, $key: 'primary');
    }
    &:hover {
      > svg {
        color: $white;
      }
    }
  }

  .c-sidebar-minimizer {
    max-width: 240px;
  }
}
</style>
